module.exports = __webpack_public_path__ + "static/Y-Verteiler-RST-5e98fc1538301d9c7d46366fd4aa666c.jpg";